import EditIcon from "@mui/icons-material/Edit";
import {
  Autocomplete,
  Checkbox,
  FormControlLabel,
  Modal,
  TextField,
  Typography,
} from "@mui/material";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarExport,
  GridToolbarQuickFilter,
} from "@mui/x-data-grid";
import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import axiosInstance from "../../Axios.jsx";
import useAuth from "../../contexts/UserContext.tsx";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  height: "95vh",
  width: "50vw",
  bgcolor: "background.paper",
  borderRadius: "10px",
  boxShadow: 24,
  overflowY: "scroll",
  p: 4,
};

export const Teacher = () => {
  const columns = [
    {
      field: "teacher_f_name",
      headerName: "First Name",
      minWidth: 200,
    },
    {
      field: "teacher_l_name",
      headerName: "Last Name",
      minWidth: 200,
    },
    {
      field: "app_user_id",
      headerName: "App User ID",
      minWidth: 150,
    },
    {
      field: "tel_no",
      headerName: "Phone Number",
      minWidth: 130,
    },
    {
      field: "password",
      headerName: "Password",
      minWidth: 150,
    },
    {
      field: "center_id",
      headerName: "Center ID",
      minWidth: 100,
    },
    {
      field: "center_name",
      headerName: "Center Name",
      minWidth: 200,
    },
    {
      headerName: "Actions",
      minWidth: 200,
      renderCell: (params) => (
        <div className="flex gap-7">
          <button
            onClick={() => {
              getCourseData(params.row.teacher_id);
              getTeacherCourseData(params.row.teacher_id);
              setTeacherUpdateObj({
                teacherID: params.row.teacher_id,
                firstname: params.row.teacher_f_name,
                lastname: params.row.teacher_l_name,
                phone: params.row.tel_no,
                currentCourses: teacherCoursesData,
                allCourses: courseData,
              });
              handleEditModalOpen();
            }}
          >
            <EditIcon />
          </button>
          {/* <button onClick={(e)=> alert("Delete clicked")}>
            <DeleteIcon />
          </button> */}
        </div>
      ),
    },
  ];

  // edit modal column
  const editModalColumn = [
    {
      field: "category_id",
      headerName: "Category ID",
    },
    {
      field: "category_name",
      headerName: "Category",
      minWidth: 250,
    },
    {
      field: "crs_title",
      headerName: "Course Title",
      minWidth: 250,
    },
  ];

  // school names
  const [schoolNames, setSchoolNames] = useState([
    {
      id: -1,
      name: "No schools",
    },
  ]);

  // edit modal
  const [openEditModal, setEditModal] = useState(false);
  const handleEditModalOpen = () => setEditModal(true);
  const handleEditModalClose = () => setEditModal(false);

  // course to be added in edit modal
  const [, setAddCourseEdit] = useState([]);

  const { user, logout } = useAuth();

  // data refractoring - school types
  const school_types = user.view_access_list.school_types
    .split(",")
    .map((item) => `'${item}'`)
    .join(",");
  const school_types_array = school_types
    .replaceAll("'", "")
    .split(",")
    .sort()
    .map((school_type) => ({
      label: school_type,
      value: school_type,
    }));

  // data refractoring - district
  const district = user.view_access_list.district
    .split(",")
    .map((district) => `'${district}`)
    .join(",");
  const district_array = district
    .replaceAll("'", "")
    .split(",")
    .sort()
    .map((d) => ({
      label: d,
      value: d,
    }));

  const [schoolTypeOptionsSelected, setSchoolTypeOptionsSelected] = useState(
    school_types_array.map((item) => item.value)
  );
  const [districtOptionsSelected, setDistrictOptionsSelected] = useState(
    district_array.map((item) => item.value)
  );
  const [schoolID, setSchoolID] = useState(0);

  const [teacherData, setTeacherData] = useState();
  const [loading, setLoading] = useState(false);

  const [reload, setReload] = useState(false);

  // edit teacher data
  const [courseData, setCourseData] = useState();
  const [teacherCoursesData, setTeacherCoursesData] = useState();

  // update teacher object
  const [teacherUpdateObj, setTeacherUpdateObj] = useState({
    teacherID: "",
    firstname: "",
    lastname: "",
    phone: "",
    currentCourses: [],
    allCourses: [],
  });

  const handleSelectAllSchoolChange = () => {
    if (schoolTypeOptionsSelected.length === school_types_array.length) {
      setSchoolTypeOptionsSelected([]);
    } else {
      setSchoolTypeOptionsSelected(
        school_types_array.map((option) => option.value)
      );
    }
  };

  const handleSelectAllDistrictChange = () => {
    if (districtOptionsSelected.length === district_array.length) {
      setDistrictOptionsSelected([]);
    } else {
      setDistrictOptionsSelected(district_array.map((option) => option.value));
    }
  };

  const handleAddCourseSelectionChange = (selectionModel) => {
    setAddCourseEdit(selectionModel);
  };

  const clickSubmitHandler = async () => {
    if (schoolID === -1) {
      toast.error("No school selected");
      return;
    }
    const school_str = schoolTypeOptionsSelected
      .map((item) => `'${item}'`)
      .join(",");
    const district_str = districtOptionsSelected
      .map((item) => `'${item}'`)
      .join(",");

    try {
      setLoading(true);
      const res = await axiosInstance.post("/getTeachers", {
        auth_token: user.auth_token,
        school_types: school_str,
        district: district_str,
        user_id: user.user_id,
        school_id: schoolID,
      });
      if (res.data.data.message === "Invalid User") {
        toast.error("Invalid User");
        logout();
        return;
      }
      setTeacherData(res.data.data.teachers);
    } catch (err) {
      alert(err.message);
    } finally {
      setLoading(false);
    }
  };

  const getCourseData = async (teacher_id) => {
    try {
      const res = await axiosInstance.post("/getCourses", {
        auth_token: user.auth_token,
        user_id: user.user_id,
        teacher_id: teacher_id,
      });
      setCourseData(res.data.data.courses);
    } catch (err) {
      alert(err.message);
    }
  };

  const getTeacherCourseData = async (teacher_id) => {
    try {
      const res = await axiosInstance.post("/getTeacherCourses", {
        auth_token: user.auth_token,
        user_id: user.user_id,
        teacher_id: teacher_id,
      });
      setTeacherCoursesData(res.data.data.teacher_courses);
    } catch (err) {
      alert(err.message);
    }
  };

  const getSchoolNames = async () => {
    const school_str = schoolTypeOptionsSelected
      .map((item) => `"${item}"`)
      .join(",");
    const district_str = districtOptionsSelected
      .map((item) => `"${item}"`)
      .join(",");

    try {
      const res = await axiosInstance.get(
        `getSchools?district=${district_str}&school_type=${school_str}&auth_token=${user.auth_token}`
      );
      let sorted_array = res.data.data.data.sort((a, b) => {
        if (a.name < b.name) return -1;
        if (a.name > b.name) return 1;
        return 0;
      });
      setSchoolNames(sorted_array);
    } catch (err) {
      setSchoolNames([
        {
          id: -1,
          name: "No schools",
        },
      ]);
      console.log(err.message);
    }
  };

  useEffect(() => {
    getSchoolNames();
    clickSubmitHandler();

    if (reload) setReload(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reload]);

  function CustomToolbarCourses() {
    return (
      <GridToolbarContainer
        sx={{ padding: 2, display: "flex", justifyContent: "space-between" }}
      >
        <GridToolbarQuickFilter />
      </GridToolbarContainer>
    );
  }

  function CustomToolbar() {
    return (
      <GridToolbarContainer
        sx={{ padding: 2, display: "flex", justifyContent: "space-between" }}
      >
        <GridToolbarQuickFilter />
        <div className="flex">
          <GridToolbarExport printOptions={{ disableToolbarButton: true }} />
        </div>
      </GridToolbarContainer>
    );
  }

  return (
    <div className="teacher-container">
      <div className="teacher-form-container flex gap-2 pt-2">
        <FormControl fullWidth>
          <InputLabel id="checkbox-dropdown-label">School Types</InputLabel>
          <Select
            labelId="checkbox-dropdown-label"
            id="checkbox-dropdown"
            multiple
            onClose={getSchoolNames}
            label="School Types"
            value={schoolTypeOptionsSelected}
            onChange={() => {}}
            renderValue={(selected) => [...selected].join(", ")}
          >
            <MenuItem key="select-all" onClick={handleSelectAllSchoolChange}>
              <FormControlLabel
                control={
                  <Checkbox
                    indeterminate={
                      schoolTypeOptionsSelected.length > 0 &&
                      schoolTypeOptionsSelected.length <
                        school_types_array.length
                    }
                    checked={
                      schoolTypeOptionsSelected.length ===
                      school_types_array.length
                    }
                  />
                }
                label="Select All"
              />
            </MenuItem>
            {school_types_array.map((option, idx) => (
              <MenuItem key={idx} value={option.value}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={schoolTypeOptionsSelected.includes(option.value)}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setSchoolTypeOptionsSelected([
                            ...schoolTypeOptionsSelected,
                            option.value,
                          ]);
                        } else {
                          setSchoolTypeOptionsSelected(
                            schoolTypeOptionsSelected.filter(
                              (type) => type !== option.value
                            )
                          );
                        }
                      }}
                    />
                  }
                  label={option.label}
                />
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl fullWidth>
          <InputLabel id="checkbox-dropdown-label">District</InputLabel>
          <Select
            labelId="checkbox-dropdown-label"
            id="checkbox-dropdown"
            multiple
            label="Districts"
            onClose={getSchoolNames}
            value={districtOptionsSelected}
            onChange={() => {}}
            renderValue={(selected) => [...selected].join(", ")}
          >
            <MenuItem key="select-all" onClick={handleSelectAllDistrictChange}>
              <FormControlLabel
                control={
                  <Checkbox
                    indeterminate={
                      districtOptionsSelected.length > 0 &&
                      districtOptionsSelected.length < district_array.length
                    }
                    checked={
                      districtOptionsSelected.length === district_array.length
                    }
                  />
                }
                label="Select All"
              />
            </MenuItem>
            {district_array.map((option, idx) => (
              <MenuItem key={idx} value={option.value}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={districtOptionsSelected.includes(option.value)}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setDistrictOptionsSelected([
                            ...districtOptionsSelected,
                            option.value,
                          ]);
                        } else {
                          setDistrictOptionsSelected(
                            districtOptionsSelected.filter(
                              (type) => type !== option.value
                            )
                          );
                        }
                      }}
                    />
                  }
                  label={option.label}
                />
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        {/* <FormControl fullWidth>
          <InputLabel id="demo-simple-select-label">Select School</InputLabel>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={schoolID}
            label="Select School"
            onChange={(e)=> {
              setSchoolID(e.target.value)
            }}
          >
            <MenuItem value={0}></MenuItem>
            {
              schoolNames && schoolNames.map((school) => (
                <MenuItem value={school.school_id}>{school.school_name}</MenuItem>
              ))
            }
          </Select>
        </FormControl> */}

        <FormControl fullWidth>
          <Autocomplete
            disablePortal
            id="combo-box-demo"
            options={schoolNames}
            getOptionLabel={(option) => option.name}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Select School"
                fullWidth
                InputLabelProps={{
                  shrink: true,
                }}
              />
            )}
            value={schoolNames.find((option) => option.id === schoolID) || null}
            onChange={(event, value) => setSchoolID(value ? value.id : null)}
            renderOption={(props, option) => (
              <li {...props}>
                <div className="flex gap-2">
                  <div>{option.name}</div>
                </div>
              </li>
            )}
          />
        </FormControl>

        <button
          onClick={clickSubmitHandler}
          className="bg-blue-500 rounded-md hover:bg-blue-700 w-[250px] text-white"
        >
          Submit
        </button>
      </div>

      <div className="teacher-table-container">
        {loading ? (
          <div className="flex justify-center items-center h-[500px]">
            <Typography variant="h5" className="text-gray-400">
              Loading...
            </Typography>
          </div>
        ) : teacherData && teacherData.length > 0 ? (
          <>
            <DataGrid
              columns={columns}
              rows={teacherData}
              rowHeight={50}
              pageSize={25}
              pagination
              disablePageSize
              sx={{ marginTop: "2.5em" }}
              autoHeight={true}
              getRowId={(row) => row.teacher_id}
              components={{
                Toolbar: CustomToolbar,
              }}
              componentsProps={{
                toolbar: {
                  showQuickFilter: true,
                  quickFilterProps: { debounceMs: 500 },
                },
              }}
            />
            <Modal
              open={openEditModal}
              onClose={handleEditModalClose}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style}>
                <Typography
                  id="modal-modal-title"
                  sx={{ marginBottom: "15px" }}
                  variant="h6"
                  component="h2"
                >
                  Edit Teacher
                </Typography>
                <div className="grid grid-cols-3 gap-3">
                  <div>
                    <label
                      for="teacher-f-name"
                      className="block text-sm font-medium text-gray-700"
                    >
                      Teacher First Name
                    </label>
                    <input
                      value={teacherUpdateObj.firstname}
                      onChange={(e) => {
                        setTeacherUpdateObj((prev) => {
                          return {
                            ...prev,
                            firstname: e.target.value,
                          };
                        });
                      }}
                      className="mt-1 p-2 border border-gray-300 rounded-md w-full focus:outline-none focus:ring focus:border-blue-100"
                      id="teacher-f-name"
                    />
                  </div>
                  <div>
                    <label
                      for="teacher-l-name"
                      className="block text-sm font-medium text-gray-700"
                    >
                      Teacher Last Name
                    </label>
                    <input
                      value={teacherUpdateObj.lastname}
                      onChange={(e) => {
                        setTeacherUpdateObj((prev) => {
                          return {
                            ...prev,
                            lastname: e.target.value,
                          };
                        });
                      }}
                      className="mt-1 p-2 border border-gray-300 rounded-md w-full focus:outline-none focus:ring focus:border-blue-100"
                      id="teacher-l-name"
                    />
                  </div>
                  <div>
                    <label
                      for="app-user-id"
                      className="block text-sm font-medium text-gray-700"
                    >
                      Phone Number
                    </label>
                    <input
                      value={teacherUpdateObj.phone}
                      onChange={(e) => {
                        setTeacherUpdateObj((prev) => {
                          return {
                            ...prev,
                            phone: e.target.value,
                          };
                        });
                      }}
                      className="mt-1 p-2 border border-gray-300 rounded-md w-full focus:outline-none focus:ring focus:border-blue-100"
                      id="app-user-id"
                    />
                  </div>
                </div>

                <div className="current-course-container">
                  {teacherUpdateObj.currentCourses && (
                    <>
                      {teacherUpdateObj.currentCourses.length > 0 ? (
                        <>
                          <Typography
                            variant="h6"
                            sx={{ marginTop: "15px" }}
                            component="h2"
                          >
                            Assigned Courses
                          </Typography>
                          <DataGrid
                            columns={editModalColumn}
                            rows={teacherUpdateObj.currentCourses}
                            rowHeight={50}
                            pageSize={25}
                            pagination
                            disablePageSize
                            sx={{ marginTop: "0.5em" }}
                            autoHeight={true}
                            getRowId={(row) => row.crs_id}
                            components={{
                              Toolbar: CustomToolbarCourses,
                            }}
                            checkboxSelection
                            onSelectionModelChange={
                              handleAddCourseSelectionChange
                            }
                          />
                        </>
                      ) : (
                        <Typography
                          variant="h6"
                          className="text-gray-400 mt-[25px]"
                        >
                          No courses assigned
                        </Typography>
                      )}
                    </>
                  )}
                </div>

                <div className="all-course-container">
                  {teacherUpdateObj.allCourses &&
                    (teacherUpdateObj.allCourses.length > 0 ? (
                      <>
                        <Typography
                          variant="h6"
                          sx={{ marginTop: "15px" }}
                          component="h2"
                        >
                          All Courses
                        </Typography>
                        <DataGrid
                          columns={editModalColumn}
                          rows={teacherUpdateObj.allCourses}
                          rowHeight={50}
                          disablePageSize
                          sx={{ marginTop: "0.5em" }}
                          autoHeight={true}
                          getRowId={(row) => row.crs_id}
                          checkboxSelection
                          onSelectionModelChange={
                            handleAddCourseSelectionChange
                          }
                        />
                      </>
                    ) : (
                      <Typography variant="h6" className="text-gray-400">
                        No courses available
                      </Typography>
                    ))}
                </div>

                <button className="bg-green-500 hover:bg-green-600 text-white font-semibold py-2 px-4 rounded focus:outline-none focus:shadow-outline-green mr-5 mt-4">
                  Submit
                </button>
              </Box>
            </Modal>
          </>
        ) : (
          <div className="flex justify-center items-center h-[500px]">
            <Typography variant="h5" className="text-gray-400">
              No data available
            </Typography>
          </div>
        )}
      </div>
    </div>
  );
};
